import * as React from 'react';
import { UIHeading2, UIHeading3 } from '@cian/ui-kit';
import { ConditionalWrapper } from '@cian/conditional-component';
import { useIsDesktop } from '@cian/valuation-utils-component';

import * as styles from './styles.css';

interface IRecommendationsProps {
  addForm: React.ReactElement;
  demandRequest: React.ReactElement;
}

export const Recommendations = React.forwardRef<HTMLDivElement, IRecommendationsProps>(
  ({ addForm, demandRequest }, ref) => {
    const isDesktop = useIsDesktop();

    return (
      <div data-testid="Recommendations" ref={ref}>
        <div className={styles['title']}>
          <ConditionalWrapper if={isDesktop} ThenComponent={UIHeading2} ElseComponent={UIHeading3}>
            Что дальше
          </ConditionalWrapper>
        </div>
        <div className={styles['content']}>
          <div className={styles['add_form']}>{addForm}</div>
          <div className={styles['realtor']}>{demandRequest}</div>
        </div>
      </div>
    );
  },
);

Recommendations.displayName = 'Recommendations';
